module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "td-user-day",
    class: {
      'td-user-day--active': _vm.isTheActiveDay
    },
    on: {
      "click": _vm.setCreateEventOnUser
    }
  }, [_c('div', {
    staticClass: "do-events"
  }, [_vm._l((_vm.filteredEvents), function(event) {
    return _c('div', {
      key: event.event_id,
      staticClass: "do-events__event do-events__event--edit",
      style: ({
        backgroundColor: event.color
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editEvent(event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(event.v_time) + "\n    ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--small btn-trans do-events__event__add-event"
  }, [_vm._v("\n      + Tilføj vagt\n    ")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0a00a9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/DutySchedulePlanCalendarUserDay.vue
// module id = 2144
// module chunks = 1